import React,{useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
//import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Box from '@material-ui/core/Box';
//import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tools} from './Tools';
import DatePick from './DatePick';
import {Dataset} from './Inc';

interface Props {
    name: string,
    value?: string | number | boolean | null,
    error?: string,
    label?: string,
    id: string,
    list?: Dataset[],
    disabledIds?: string[],
    icon?:string,
    iconTitle?:string,
    type: "text" | "textarea" | "select" | "radio" | "date" | "switch" | "onoff" | "onoff2" | "number" | "checkbox" | "menu",
    useBool?: boolean,
    pattern?: "email" | "tel" | "url",
    required?:boolean,
    fullWidth?:boolean,
    startAdornment?:string,
    endAdornment?:string,
    notEmpty?:boolean,
    helper?:string,
    maxLength?:number,
    minLength?:number,
    maxRange?:number,
    minRange?:number,
    rows?:number,
    dense?:boolean,
    placeholder?:string,
    hankaku?:boolean,
	noName?:boolean,
	colored?:boolean,
    change(name:string,value:string | number | boolean): void,
    addError?(name:string,flag:boolean): void,
    blur?(): void,
    focus?(): void,
    onIconClick?(): void,
}

const ColInput:React.FC<Props> = (props)=> {
    let error = "";
    let value = "";
    let clicked = false;
    if( props.useBool ){
        if( props.value===true ){
            value = "1";
        } else {
            value = "0";
        }
    } else {
        if( props.type === "number" ){
            if( props.value!==null ){
                value = String(props.value);
            }
        } else if( typeof props.value === "string" ){
            value = props.value;
        }
    }

    const [states,setStates] = useState({
        isCalendar: false,
    });
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
	const openMenu = (event: React.MouseEvent<HTMLElement>) => {
		if( props.list && props.list.length>0 ){
			setAnchorEl(event.currentTarget);
		}
	};
  
	const clickMenu = (event: React.MouseEvent<HTMLElement>, index: number) => {
		if( !props.list ){
			return;
		}
		let v = "";
		if( index>=0 && props.list[index] ){
			v = props.list[index].id;
		}
		setAnchorEl(null);
		props.change(props.id,v);
	};
  
	const closeMenu = () => {
		setAnchorEl(null);
	};

	const changeInput = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        //const isError = validate();
        let value = event.target.value;
        if( props.hankaku ){
            value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
                return String.fromCharCode(s.charCodeAt(0) - 65248);
            });
            value = value.replace(/あ/g,"a");
            value = value.replace(/い/g,"i");
            value = value.replace(/う/g,"u");
            value = value.replace(/え/g,"e");
            value = value.replace(/お/g,"o");
            value = value.replace(/ー/g,"-");
            value = value.replace(/―/g,"-");
            value = value.replace(/‐/g,"-");
			value = value.replace(/－/g,"-");
            value = value.replace(/[^A-Z^a-z\d-]/g, '');
        }
        if( props.type === "number" ){
            value = Tools.toHan(value);
            if( Tools.isNumber(value) ){
                props.change(name,parseInt(value));
            } else {
                props.change(name,"");
            }
        } else if( props.useBool ){
            if( value === "1" ){
                props.change(name,true);
            } else {
                props.change(name,false);
            }
        } else {
            props.change(name,value);
        }
    };
    const changeSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
        //setAge(event.target.value as string);
        props.change(props.id,event.target.value as string);
    };    
	const changeRadio = (name:string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        //const isError = validate();
        if( props.useBool ){
            if( event.target.value === "1" ){
                props.change(name,true);
            } else {
                props.change(name,false);
            }
        } else {
            props.change(name,event.target.value);
        }
    };
    const changeSwitch = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if( event.target.checked ){
            props.change(name,true);
        } else {
            props.change(name,false);
        }
    };    
    const changeDate = (dt:string) => {
        props.change(props.id,dt);
        setStates({...states,isCalendar:false});
    }
    const blur = (name: string)=>{
		//console.log("blur");
		let value = "";
        if( props.type === "number" ){
            if( props.value!==null ){
                value = String(props.value);
            }
        } else if( typeof props.value === "string" ){
            value = props.value;
        }
        if( props.pattern==="tel" ){
            value = value.replace(/ー/g,"-");
            value = value.replace(/―/g,"-");
            value = value.replace(/‐/g,"-");
			value = value.replace(/－/g,"-");
			value = Tools.toHan(value);
            value = value.replace("--","-");
            value = value.replace(/[^0-9-]/i,"");
        }
        if( props.pattern==="email" ){
            value = Tools.toHan(value);
        }
        if( props.type === "number" ){
            value = Tools.toHan(value);
            if( Tools.isNumber(value) ){
                props.change(name,parseInt(value));
            } else {
                props.change(name,"");
            }
        } else {
            props.change(name,value);
        }
		
		if( props.blur ){
            props.blur();
        }
    }
    const focus = ()=>{
        if( props.focus ){
            props.focus();
        }
    }
    const openCalendar = ()=>{
        if(clicked){
            clicked = false;
            return;
        }
        setStates({...states,isCalendar:true});
    }
    const closeCalendar = ()=>{
        setStates({...states,isCalendar:false});
    }
    const validate = ()=>{
        error = "";
        if( props.error ){
            error = props.error;
            //console.log("error",error);
        }
        if( required && (!value || value==="") ){
            error = "省略できません";
        }
        if( props.maxRange || props.maxRange===0 ){
            if( value ){
                if( parseInt(value) > props.maxRange ){
                    error = String(props.maxRange) + "以下にして下さい";
                }
            }
        }
        if( props.minRange || props.minRange===0 ){
            if( value ){
                if( parseInt(value) < props.minRange ){
                    error = String(props.minRange) + "以上にして下さい";
                }        
            }
        }
        if( props.maxLength || props.maxLength===0 ){
            if( value ){
                if( value.length > props.maxLength ){
                    error = String(props.maxLength) + "文字以内にして下さい";
                }
            }
        }
        if( props.minLength || props.minLength===0 ){
            if( value ){
                if( value.length < props.minLength ){
                    error = String(props.minLength) + "文字以上にして下さい";
                }
            }
        }
        if( props.type==="date" && value!=="" ){
            if(!value.match(/^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/)){
                error = "存在する日付を入力して下さい";
            }
        }
        if( error !=="" ){
            if( props.addError ){
                props.addError(props.id,true);
            }
            return true;
        } else {
            if( props.addError ){
                props.addError(props.id,false);
            }
            return false;
        }
    }
    const clickIcon = ()=>{
        if( props.onIconClick ){
            clicked = true;
            props.onIconClick();
        }
    }


    let required = false;
    if( props.required && props.required===true ){
        required = true;
    }

    let notEmpty = false;
    if( required ){
        notEmpty = true;
    } else if( props.notEmpty && props.notEmpty===true ){
        notEmpty = true;
    }

    let inputProps = {};
    if( props.startAdornment && props.endAdornment ){
        inputProps = {
            endAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="end">{props.endAdornment}</InputAdornment>,
            startAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="start">{props.startAdornment}</InputAdornment>,
        }
    } else if( props.endAdornment ){
        inputProps = {
            endAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="end">{props.endAdornment}</InputAdornment>,
        }
    } else if( props.startAdornment ){
        inputProps = {
            startAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="start">{props.startAdornment}</InputAdornment>,
        }
    } else if( props.icon ){
        let icon = <AddIcon/>
        let title = "";
        if( props.icon==="cancel" ){
            icon = <CancelIcon/>
        } else if( props.icon==="robot" ){
            icon = <FontAwesomeIcon icon="robot"/>
        }
        if( props.iconTitle ){
            title = props.iconTitle;
        }
        inputProps = {
            endAdornment: 
              <InputAdornment position="end">
                <Tooltip title={title}><IconButton
                  aria-label="toggle password visibility"
                  onClick={clickIcon}
                >
                    {icon}
                </IconButton></Tooltip>
              </InputAdornment>
            ,
        }
    }

    let name = "　";
    if( props.name ){
        name = props.name;
    }

    let rows = 3;
    if( props.rows ){
        rows = props.rows;
    }

    let cl = "formControl";
    if( props.dense ){
        cl = "formControl formControlDense";
    }

    let noName = false;
    if( props.noName ){
        noName = true;
    }

	let selectedMenu = "";
	if(props.list && props.list.length>0 && value && value!==""){
		selectedMenu = Tools.getLabel(props.list,value);
	}
	if( selectedMenu==="" ){
		if( props.label ){
			selectedMenu = props.label;
		} else {
			selectedMenu = "　";
		}
	}

	let colored = {backgroundColor:"#FFFFFF",padding:"0em",paddingBottom:"0"};
	if( props.colored ){
		colored = {backgroundColor:"#F5FFF0",padding:"0em",paddingBottom:"0"};
	}

    validate();

    return (
    <React.Fragment>
        <FormControl fullWidth={true} required={required} error={error!==""} className={cl}>
            {!noName && <FormLabel component="label" className="formLabel">{name}</FormLabel>}
            {props.type==="text" &&
            <TextField
                id={props.id}
                value={value}
                onChange={changeInput(props.id)}
                onBlur={()=>blur(props.id)}
                onFocus={focus}
                margin="dense"
                InputProps={inputProps}
                placeholder={props.placeholder}
                //variant="outlined"
            />
            }

            {props.type==="number" &&
            <TextField
                id={props.id}
                value={value}
                onChange={changeInput(props.id)}
                onBlur={()=>blur(props.id)}
                onFocus={focus}
                margin="dense"
                InputProps={inputProps}
                placeholder={props.placeholder}
                //variant="outlined"
            />
            }

            {props.type==="date" &&
            <TextField
                id={props.id}
                value={value}
                onChange={changeInput(props.id)}
                onBlur={()=>blur(props.id)}
                onFocus={openCalendar}
                onClick={openCalendar}
                margin="dense"
                placeholder={props.placeholder}
                InputProps={inputProps}
                //variant="outlined"
            />
            }

            {props.type==="select" &&
                <Select
                    native
                    value={value}
                    onChange={changeSelect}
                    inputProps={{
                        name: props.id,
                        id: props.id,
                    }}
                    margin="none"
                    style={{marginTop:"0.31em"}}
                    id={props.id}
                >
                    {!notEmpty &&
                    <option key="option0" value=""></option>
                    }
                    {props.list && 
                        props.list.map((option:Dataset,index:number) => {
                            const key = "option"+index;
                            return (
                                <option key={key} value={option.id} disabled={props.disabledIds && props.disabledIds.includes(option.id)}>
                                    {option.label}
                                </option>
                            )
                        })
                    }
                </Select>
            }

			{props.type==="menu" &&
			<Box>
				<List component="nav">
					<ListItem
						button
						aria-haspopup="true"
						aria-controls="lock-menu"
						aria-label="menu"
						onClick={openMenu}
						style={{marginTop:"-0.25em",padding:"0 0.25em",paddingRight:"1.5em",borderBottom:"1px solid #999999",position:"relative"}}
					>
						<ListItemText primary={selectedMenu}/>
						<div style={{position:"absolute",top:"50%",right:"0.4em",transform:"translate(0%, -50%)"}}>
							<IconButton size="small" edge="end" aria-label="delete">
								<FontAwesomeIcon icon="caret-down"/>
							</IconButton>
						</div>
					</ListItem>
				</List>
				<Menu
					id="lock-menu"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={closeMenu}
				>
                    {!notEmpty &&
					<MenuItem
						key="option0"
						selected={value === ""}
						onClick={(event) => clickMenu(event, -1)}
						style={{whiteSpace:"normal",fontSize:"100%"}}				
					>　</MenuItem>
                    }
					{props.list && props.list.map((option:Dataset, index) => (
					<MenuItem
						key={option.id}
						disabled={props.disabledIds && props.disabledIds.includes(option.id)}
						selected={option.id === value}
						onClick={(event) => clickMenu(event, index)}
						style={{whiteSpace:"normal",fontSize:"100%"}}
					>
						{option.label}
					</MenuItem>
					))}
				</Menu>
			</Box>
			}

            {props.type==="textarea" &&
            <TextField
                id={props.id}
                value={value}
                onChange={changeInput(props.id)}
                margin="dense"
                rows={rows}
				//variant="outlined"
				style={colored}
                multiline
            />
            }

            {props.type==="radio" &&
			<RadioGroup
                value={value}
                row
            >
                {props.list &&
                    props.list.map((data:Dataset,index:number)=>{
                    const key = "radio"+index;
                    return (
                        <FormControlLabel key={key} value={data.id} control={<Radio color="primary" onChange={changeRadio(props.id)}/>} label={data.label} />
                    );
                })}
			</RadioGroup>
            }

            {props.type==="switch" &&
            <FormControlLabel
                control={
                <Switch
                    checked={value==="1"}
                    onChange={changeSwitch(props.id)}
                    value="1"
                    color="primary"
                    size="small"
                />
                }
                label={props.label}
            />
            }

            {props.type==="onoff" &&
            <div style={{paddingLeft:"1em",paddingTop:"0.5em",paddingBottom:"0.1em",borderBottom:"1px solid #999999"}}>
                <Switch
                    checked={value==="1"}
                    onChange={changeSwitch(props.id)}
                    value="1"
                    size="small"
					color="default"
					style={{color:value==='1' ? 'green':'silver'}}
                />
                {value==="1" ? (
                    <span style={{fontWeight:"bold"}}>ON</span>
                ):(
                    <span style={{color:"#CCCCCC"}}>OFF</span>
                )}
            </div>
            }

            {props.type==="onoff2" &&
            <div style={{paddingLeft:"1em",paddingTop:"0.5em",paddingBottom:"0.1em"}}>
                <Switch
                    checked={value==="1"}
                    onChange={changeSwitch(props.id)}
                    value="1"
                    color="primary"
                    size="small"
                />
                {value==="1" ? (
                    <span style={{fontWeight:"bold"}}>ON</span>
                ):(
                    <span style={{color:"#CCCCCC"}}>OFF</span>
                )}
            </div>
            }

            {props.type==="checkbox" &&
            <div style={{paddingLeft:"1em",paddingTop:"0.5em",paddingBottom:"0.1em"}}>
				<FormControlLabel
					control={
					<Checkbox
						checked={value==="1"}
						onChange={changeSwitch(props.id)}
						name="checkedB"
						color="primary"
					/>
					}
					label={props.label}
				/>
            </div>
            }

            {props.helper && error==="" &&
            <FormHelperText>※{props.helper}</FormHelperText>
            }
            {error!=="" &&
            <FormHelperText>※{error}</FormHelperText>
            }
        </FormControl>
        <DatePick isOpen={states.isCalendar} close={closeCalendar} change={changeDate} value={value}/>
    </React.Fragment>
    );
}

export default ColInput;
